import { Button, CopyValue } from '@components'
import { canUseNativeShare } from '@utils/canUseNativeShare'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { FaShareAlt } from 'react-icons/fa'
import styled from 'styled-components'
import toast from 'react-hot-toast'

interface ReferralShareLinkProps {
  url: string
  shareTitle: string
  shareMessage: string
}

export const ReferralShareLink: React.FC<ReferralShareLinkProps> = ({
  url,
  shareTitle,
  shareMessage
}) => {
  const [t] = useTranslation()
  const showShareButton = canUseNativeShare({ url, title: shareTitle, text: shareMessage })

  const handleNativeShare = async () => {
    try {
      await navigator.share({
        title: shareTitle,
        text: shareMessage,
        url
      })
    } catch (error) {
      if (error instanceof DOMException && error.name === 'AbortError') {
        return
      }

      toast.error(t('settings.referral.shareError'))
    }
  }

  return (
    <Wrapper>
      <CopyValueWrapper>
        <CopyValue value={url} maxLines={2} />
      </CopyValueWrapper>
      {showShareButton && (
        <ShareButton
          type="button"
          isSecondary
          icon={<FaShareAlt />}
          aria-label={t('settings.referral.shareButton')}
          onClick={() => void handleNativeShare()}
        />
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing.xs}rem;
  align-items: stretch;
  width: 100%;
  min-width: 0;
`

const CopyValueWrapper = styled.div`
  flex: 1 1 12rem;
  min-width: 0;
`

const ShareButton = styled(Button)`
  flex-shrink: 0;
  align-self: stretch;
`
